"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PublicTransitSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M5 4a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5zm3 4.5a.5.5 0 0 1 .5-.5h3.732a.5.5 0 0 1 .477.35l3.358 10.633c.003.012.014.02.026.02a.028.028 0 0 0 .027-.02l3.175-10.626a.5.5 0 0 1 .48-.357H23.5a.5.5 0 0 1 .5.5v15a.5.5 0 0 1-.5.5h-2.058a.5.5 0 0 1-.5-.5V12.685a.024.024 0 0 0-.047-.007L17.37 23.653a.5.5 0 0 1-.476.347h-1.79a.5.5 0 0 1-.475-.346L11.105 12.79a.024.024 0 0 0-.047.007V23.5a.5.5 0 0 1-.5.5H8.5a.5.5 0 0 1-.5-.5v-15z" clip-rule="evenodd" stroke="none"></path>';
var PublicTransitSVG = function PublicTransitSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.PublicTransitSVG = PublicTransitSVG;
PublicTransitSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PublicTransitSVG);
exports.default = _default;